import { render } from "./App.vue?vue&type=template&id=d42957a0&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=d42957a0&lang=css"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__